import React, { useEffect, useState } from 'react';
import { useTelegram } from '../useTelegram';

function TelegramOnly({ children }) {
  const { isReady, isTelegram } = useTelegram();
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    if (isReady || isTelegram) {
      setChecking(false);
      return;
    }

    const timer = setTimeout(() => {
      setChecking(false);
    }, 3000);

    return () => clearTimeout(timer);
  }, [isReady, isTelegram]);

  if (checking || (isTelegram && !isReady)) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        backgroundColor: '#FFB6C1',
        color: '#333',
        fontSize: '1.5rem',
        textAlign: 'center',
        padding: '20px'
      }}>
        در حال بارگذاری...
      </div>
    );
  }

  if (!isTelegram) {
    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        backgroundColor: '#FFB6C1',
        color: '#333',
        padding: '20px',
        textAlign: 'center'
      }}>
        <div style={{ fontSize: '4rem', marginBottom: '20px' }}>⚠️</div>
        <h1 style={{ fontSize: '2rem', marginBottom: '20px', color: '#FF69B4' }}>
          دسترسی محدود
        </h1>
        <p style={{ fontSize: '1.2rem', lineHeight: '1.8', maxWidth: '500px' }}>
          این برنامه فقط از طریق ربات پیام‌رسان بله قابل دسترسی است.
          <br />
          لطفاً از طریق ربات بله به این برنامه دسترسی پیدا کنید.
        </p>
      </div>
    );
  }

  return children;
}

export default TelegramOnly;
